import Header from '@/uiKit/BrandedDialog/Header.vue'
import Root from '@/uiKit/BrandedDialog/Root.vue'

const BrandedDialog = {
  Root,
  Header,
}

export default BrandedDialog
